<template>
  <div ref="root" class="mx-auto w-full max-w-5xl px-4">
    <p class="font-mono text-sm text-[var(--accent)]">{{ t('stack.title') }}</p>
    <h2 class="mt-1 text-2xl font-bold">{{ t('stack.heading') }}</h2>
    <div
      data-reveal-group
      class="mt-5 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3"
    >
      <TechBadge v-for="item in stack" :key="item.title" :item="item" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { stack } from '../data'
import TechBadge from '../components/TechBadge.vue'
import { useReveal } from '../composables/useMotion'

const { t } = useI18n()
const root = ref<HTMLElement | null>(null)
useReveal(root)
</script>
